"use client";

import React from "react";
import CrmVendorSection from "./CrmVendorSection";
import { useServiceData } from "../../hooks/useServiceData";

export default function CrmVendors() {
  const { data: backendPageData } = useServiceData();

  // Look for a section of type "alternatingSection" in dynamic data
  const dynamicAlternating = backendPageData?.extraSections?.find(
    (s) => s.type === "alternatingSection"
  )?.refId;

  // FALLBACK: Static data from your code
  const staticData = [
    {
      tag: "HUBSPOT CRM",
      title: "HubSpot Implementation & Optimization",
      description: "From clean setup to workflows, playbooks, and dashboards across Sales, Marketing, and Service hubs.",
      points: [
        { text: "Sales/Marketing/Service Hubs" },
        { text: "Workflows & Sequences" },
        { text: "Lead Scoring" },
        { text: "Dashboards & KPIs" },
      ],
      image: "/assets/img/crm/hubspot.webp",
      logoClassName: "fa-brands fa-hubspot",
    },
    {
      tag: "ZOHO CRM",
      title: "Zoho CRM Customization & Integrations",
      description: "Tailored modules, automations, and integrations with Books, Desk, and third‑party tools.",
      points: [
        { text: "Custom Modules" },
        { text: "Blueprints & Automations" },
        { text: "Zoho Books/Desk" },
        { text: "3rd‑Party Integrations" },
      ],
      image: "/assets/img/crm/zoho.webp",
      logoClassName: "fa-solid fa-z",
      reverse: true,
    }
  ];

  const itemsToDisplay = dynamicAlternating?.items || staticData;

  const getImageUrl = (url) => {
    if (!url || typeof url !== "string") return "";
    if (url.startsWith("data:") || url.startsWith("blob:")) return url;
    
    const apiUrl = (process.env.NEXT_PUBLIC_API_URL || process.env.NEXT_PUBLIC_API_BASE_URL || '').replace(/\/api\/?$/, '').replace(/\/$/, '') || "";
    
    if (url.includes("/uploads/")) {
      const cleanPath = url.substring(url.indexOf("/uploads/"));
      return `${apiUrl}${cleanPath}`;
    }
    
    if (url.startsWith("uploads/") || url.startsWith("/uploads/")) {
      const cleanPath = url.startsWith("/") ? url : `/${url}`;
      return `${apiUrl}${cleanPath}`;
    }
    
    if (url.startsWith("http")) return url;
    return url;
  };

  return (
    <>
      {itemsToDisplay.map((item, index) => (
        <CrmVendorSection
          key={index}
          eyebrow={item.tag}
          title={item.title}
          body={item.description}
          bullets={item.points?.map(p => p.text)}
          imageSrc={getImageUrl(item.image)}
          imageAlt={item.title}
          reverse={item.reverse || index % 2 !== 0}
          logoClassName={item.logoClassName}
          ctaHref={item.buttonLink || "/contact"}
          ctaText={item.buttonText || "Learn More"}
        />
      ))}
    </>
  );
}
